module.exports = __webpack_public_path__ + "static/media/peach-cat.89a56112.gif";